/* Toni Pons — unified wishlist behavior bridge */
(function () {
  'use strict';

  var STORAGE_KEY = 'wishlistItem';
  var PDP_SELECTOR = '[data-tp-pdp-wishlist][data-wishlist-handle]';
  var STANDARD_SELECTOR = '[data-wishlist][data-wishlist-handle]';
  var REMOVE_SELECTOR = '[data-wishlist-remove-item]';

  function isArabic() {
    return document.documentElement.dir === 'rtl' ||
      /^ar(?:-|$)/i.test(document.documentElement.lang || '');
  }

  function readWishlist() {
    try {
      var parsed = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
      if (!Array.isArray(parsed)) return [];
      return Array.from(new Set(parsed.map(String).filter(Boolean)));
    } catch (error) {
      return [];
    }
  }

  function writeWishlist(items) {
    var clean = Array.from(new Set((items || []).map(String).filter(Boolean)));
    localStorage.setItem(STORAGE_KEY, JSON.stringify(clean));
    window.dispatchEvent(new CustomEvent('tp:wishlist-updated', {
      detail: { items: clean.slice() }
    }));
    return clean;
  }

  function labels(active) {
    if (isArabic()) {
      return active
        ? { aria: 'إزالة من المفضلة', text: 'إزالة من المفضلة' }
        : { aria: 'إضافة إلى المفضلة', text: 'إضافة للمفضلة' };
    }
    return active
      ? { aria: 'Remove from wishlist', text: 'Remove from wishlist' }
      : { aria: 'Add to wishlist', text: 'Add to wishlist' };
  }

  function updateButton(button, active) {
    if (!button) return;
    var copy = labels(active);

    button.classList.toggle('wishlist-added', active);
    button.setAttribute('aria-pressed', active ? 'true' : 'false');
    button.setAttribute('aria-label', copy.aria);

    var text = button.querySelector('.text, .visually-hidden');
    if (text) text.textContent = copy.text;
  }

  function sync(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    var current = new Set(readWishlist());
    var selector = PDP_SELECTOR + ',' + STANDARD_SELECTOR;

    if (root.matches && root.matches(selector)) {
      updateButton(root, current.has(String(root.dataset.wishlistHandle || '')));
    }

    root.querySelectorAll(selector).forEach(function (button) {
      updateButton(button, current.has(String(button.dataset.wishlistHandle || '')));
    });

    return Array.from(current);
  }

  function togglePdp(button) {
    var handle = String(button.dataset.wishlistHandle || '').trim();
    if (!handle) return;

    var items = readWishlist();
    var index = items.indexOf(handle);
    var active;

    if (index === -1) {
      items.push(handle);
      active = true;
    } else {
      items.splice(index, 1);
      active = false;
    }

    writeWishlist(items);
    sync(document);
    repairWishlistPage();

    button.dispatchEvent(new CustomEvent('tp:wishlist-toggle', {
      bubbles: true,
      detail: { handle: handle, added: active }
    }));
  }

  function getWishlistContainer() {
    return document.querySelector('[data-wishlist-container], .wishlist-container');
  }

  function getWishlistFooter() {
    return document.querySelector('[data-wishlist-footer], .wishlist-footer');
  }

  function translatedEmptyCopy() {
    var translations = window.wishlist || {};
    var ar = isArabic();
    return {
      title: translations.empty || (ar ? 'قائمة المفضلة فارغة' : 'Your wishlist is empty'),
      text: ar
        ? 'احفظي التصاميم التي تحبينها هنا للعودة إليها بسهولة.'
        : 'Save the styles you love here so you can return to them easily.',
      button: translations.continue_shopping || (ar ? 'متابعة التسوق' : 'Continue shopping')
    };
  }

  function emptyMarkup() {
    var copy = translatedEmptyCopy();
    var url = (window.routes && window.routes.collection_all) || '/collections/all';
    return '' +
      '<div class="tp-wishlist-empty" data-tp-wishlist-empty>' +
        '<h2 class="tp-wishlist-empty__title">' + escapeHtml(copy.title) + '</h2>' +
        '<p class="tp-wishlist-empty__text">' + escapeHtml(copy.text) + '</p>' +
        '<a class="button tp-wishlist-empty__button" href="' + escapeAttribute(url) + '">' +
          escapeHtml(copy.button) +
        '</a>' +
      '</div>';
  }

  function escapeHtml(value) {
    var div = document.createElement('div');
    div.textContent = String(value == null ? '' : value);
    return div.innerHTML;
  }

  function escapeAttribute(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/"/g, '&quot;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');
  }

  function repairWishlistPage() {
    var container = getWishlistContainer();
    if (!container) return;

    var footer = getWishlistFooter();
    var items = readWishlist();

    if (items.length === 0) {
      container.classList.add('is-empty');
      if (!container.querySelector('[data-tp-wishlist-empty]')) {
        container.innerHTML = emptyMarkup();
      }
      if (footer) footer.hidden = true;
    } else {
      container.classList.remove('is-empty');
      var injectedEmpty = container.querySelector('[data-tp-wishlist-empty]');
      if (injectedEmpty) injectedEmpty.remove();
      if (footer) footer.hidden = false;
    }
  }

  function deferredSync() {
    window.setTimeout(function () { sync(document); repairWishlistPage(); }, 0);
    window.setTimeout(function () { sync(document); repairWishlistPage(); }, 120);
    window.setTimeout(function () { sync(document); repairWishlistPage(); }, 350);
  }

  document.addEventListener('click', function (event) {
    var pdpButton = event.target.closest && event.target.closest(PDP_SELECTOR);
    if (pdpButton) {
      event.preventDefault();
      event.stopPropagation();
      togglePdp(pdpButton);
      return;
    }

    var standardButton = event.target.closest && event.target.closest(STANDARD_SELECTOR);
    if (standardButton) {
      deferredSync();
    }

    var removeButton = event.target.closest && event.target.closest(REMOVE_SELECTOR);
    if (removeButton) {
      deferredSync();
    }
  });

  window.addEventListener('storage', function (event) {
    if (event.key === STORAGE_KEY) {
      sync(document);
      repairWishlistPage();
    }
  });

  window.addEventListener('tp:wishlist-updated', function () {
    sync(document);
    repairWishlistPage();
  });

  document.addEventListener('shopify:section:load', function (event) {
    sync(event.target);
    repairWishlistPage();
  });

  function init() {
    sync(document);
    repairWishlistPage();
    window.setTimeout(function () { sync(document); repairWishlistPage(); }, 250);
  }

  window.ToniPonsWishlist = {
    read: readWishlist,
    sync: sync,
    repair: repairWishlistPage
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
